import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ipponApi from "../config/axios";
import { ClientsType } from "../types";

const BaseURL = import.meta.env.VITE_API_URL;

export const fetchDetailedClient = createAsyncThunk<any, any>(
  "clients/fetchDetailedClient",
  async (id, { rejectWithValue }) => {
    try {
      const result = await ipponApi.get(`${BaseURL}/api/v1/clients/${id}`);
      return result.data.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred during getting detail of clients"
      );
    }
  }
);

export const updateDetailedClient = createAsyncThunk<any, any>(
  "clients/updateDetailedClient",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const result = await ipponApi.put(
        `${BaseURL}/api/v1/clients/${id}`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return result.data.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred during updating detail of clients"
      );
    }
  }
);

export const fetchClientName = createAsyncThunk<any, any>(
  "clients/fetchClientName",
  async (clientId, { rejectWithValue }) => {
    try {
      const result = await ipponApi.get(
        `${BaseURL}/api/v1/clients/${clientId}/name`
      );
      return result.data.data.client_name;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || "An error occurred during getting client name"
      );
    }
  }
);

const initialState: ClientsType = {
  detailed: {
    data: {},
    loading: false,
    error: false,
    isFetching: false,
    isUpdating: false,
  },
  name: {
    data: undefined,
    loading: false,
    error: false,
  },
};

export const clientsSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDetailedClient.fulfilled, (state, action) => {
      state.detailed.data = action.payload;
      state.detailed.isFetching = false;
      state.detailed.error = false;
    });
    builder.addCase(fetchDetailedClient.pending, (state) => {
      state.detailed.isFetching = true;
      state.detailed.error = false;
    });
    builder.addCase(fetchDetailedClient.rejected, (state) => {
      state.detailed.isFetching = false;
      state.detailed.error = true;
    });
    builder.addCase(updateDetailedClient.fulfilled, (state, action) => {
      state.detailed.data = action.payload;
      state.detailed.isUpdating = false;
      state.detailed.error = false;
    });
    builder.addCase(updateDetailedClient.pending, (state) => {
      state.detailed.isUpdating = true;
      state.detailed.error = false;
    });
    builder.addCase(updateDetailedClient.rejected, (state) => {
      state.detailed.isUpdating = false;
      state.detailed.error = true;
    });
    builder.addCase(fetchClientName.fulfilled, (state, action) => {
      state.name.data = action.payload;
      state.name.loading = false;
      state.name.error = false;
    });
    builder.addCase(fetchClientName.pending, (state) => {
      state.name.loading = true;
      state.name.error = false;
    });
    builder.addCase(fetchClientName.rejected, (state) => {
      state.name.loading = false;
      state.name.error = true;
    });
  },
});

export default clientsSlice.reducer;
